import { 
    CREATEPHARMACYBILL, CREATEPHARMACYBILLMEDICINE, CREATEPHARMACYBILLTRANSACTION, DELETEPHARMACYBILL, DELETEPHARMACYBILLMEDICINE, DELETEPHARMACYBILLTRANSACTION, GETPHARMACYBILL, GETPHARMACYBILLMEDICINE, GETPHARMACYBILLTRANSACTION, UPDATEPHARMACYBILL, UPDATEPHARMACYBILLMEDICINE, UPDATEPHARMACYBILLTRANSACTION } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEPHARMACYBILL:
            return {
                ...state,
                pharmacybillSaveStatus: action.payload.success,
            }
        case GETPHARMACYBILL:
                return {
                        ...state,
                        pharmacybillList: action.payload.data,
                        }
        case UPDATEPHARMACYBILL:
                return {
                        ...state,
                        pharmacybillUpdateStatus: action.payload.success,
                        }   

        case DELETEPHARMACYBILL:
                 return {
                     ...state,
                     pharmacybillDeleteStatus: action.payload.success,
                        } 
        case CREATEPHARMACYBILLMEDICINE:
            return {
                ...state,
                pharmacybillmedicineSaveStatus: action.payload.success,
            }
        case GETPHARMACYBILLMEDICINE:
                return {
                        ...state,
                        pharmacybillmedicineList: action.payload.data,
                        }
        case UPDATEPHARMACYBILLMEDICINE:
                return {
                        ...state,
                        pharmacybillmedicineUpdateStatus: action.payload.success,
                        }   

        case DELETEPHARMACYBILLMEDICINE:
                 return {
                     ...state,
                     pharmacybillmedicineDeleteStatus: action.payload.success,
                        } 
        case CREATEPHARMACYBILLTRANSACTION:
            return {
                ...state,
                    pharmacybilltransactionSaveStatus: action.payload.success,
            }
        case GETPHARMACYBILLTRANSACTION:
                return {
                        ...state,
                        pharmacybilltransactionList: action.payload.data,
                        }
      
        case UPDATEPHARMACYBILLTRANSACTION:
                return {
                        ...state,
                        pharmacybilltransactionUpdateStatus: action.payload.success,
                        }   

        case DELETEPHARMACYBILLTRANSACTION:
                 return {
                     ...state,
                     pharmacybilltransactionDeleteStatus: action.payload.success,
                        } 
                        default:
                            return state
                             }
                         }